export * from './HeroSimple'
